import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import logoiconsmall from "../../../assets/img/logo-icon-small.svg";
import logotextsmall from "../../../assets/img/logo-text-small.svg";
import useApi from "../../../hooks/useApi";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import { useNavigate } from "react-router-dom";
import MobileNavigation from "./MobileNavigation";
import { DownOutlined } from "@ant-design/icons";
import SearchComponent from "./SearchComponent";

const Navigation = ({ isTabletOrMobile }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [current, setCurrent] = useState("Home");
  const [openKeys, setOpenKeys] = useState();
  const [searchExpanded, setSearchExpanded] = useState(false);

  const navigate = useNavigate();
  const [menuItemResponse, menuItemRequest] = useApi(
    "/website/home/menu-dropdown",
    null,
    API_METHODS.GET
  );

  const onClick = (item) => {
    setCurrent(item.key);
    if (item.key === "Home") {
      navigate("");
    } else if (item.key === "about") {
      navigate("/about");
    } else if (item.key === "contact") {
      navigate("/contact");
    } else if (item.key === "policy") {
      navigate("/privacy");
    } else {
      let category_url = item.item.props.url;
      let main_category_url = item.keyPath[1];
      navigate(`/${main_category_url}/${category_url}`);
    }
  };

  const onOpenChange = (value) => {
    if (value?.length > 0) {
      setCurrent(value[0]);
      if (value[0] !== "Company") {
        const selectedCategory = menuItems.find(
          (element) => element.key === value[0]
        );
        const item = selectedCategory.children[0];
        let category_url = item.url;
        let main_category_url = value[0];
        navigate(`/${main_category_url}/${category_url}`);
      }
    }
  };

  const handleContactClick = () => {
    navigate("/contact");
  };

  const handleSearchIconClick = () => {
    setSearchExpanded(true);
  };

  useEffect(() => {
    menuItemRequest();
  }, []);

  useEffect(() => {
    const data =
      menuItemResponse.data !== BLANK_VALUE ? menuItemResponse.data : [];
    if (!isTabletOrMobile) {
      data?.forEach((menu) => {
        if (menu.key !== "Home") {
          menu.label = (
            <span>
              {menu.label}
              <DownOutlined />
            </span>
          );
        }
        // Add custom class for Company submenu
        if (menu.key === "Company") {
          menu.popupClassName = "company-submenu-popup";
        }
      });
    }
    setMenuItems(data);
  }, [menuItemResponse]);

  return (
    <div className="navigation-container">
      {/* Logo Section */}
      <div className="logo-section">
        <img src={logoiconsmall} alt="Logo Icon" />
        <img src={logotextsmall} alt="Logo Text" />
      </div>

      {/* Desktop Menu Section */}
      {!isTabletOrMobile && (
        <div className="menu-section navigation-container">
          <Menu
            openKeys={openKeys}
            onClick={onClick}
            onOpenChange={onOpenChange}
            triggerSubMenuAction="click"
            selectedKeys={[current]}
            mode="horizontal"
            items={menuItems}
            className="custom-menu"
          />
        </div>
      )}

      {/* Mobile Menu Section */}
      {isTabletOrMobile && (
        <div className="mobile-menu-section">
          <MobileNavigation
            openKeys={openKeys}
            onClick={onClick}
            onOpenChange={onOpenChange}
            forceSubMenuRender
            triggerSubMenuAction="hover"
            selectedKeys={[current]}
            menuItems={menuItems}
          />
        </div>
      )}

      {/* Search Component */}
      <SearchComponent
        searchExpanded={searchExpanded}
        setSearchExpanded={setSearchExpanded}
        isTabletOrMobile={isTabletOrMobile}
      />

      {/* Search Icon - Always visible before Contact Us */}
      <div className="search-icon-section" style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: isTabletOrMobile ? '10px' : '20px'
      }}>
        <div
          onClick={handleSearchIconClick}
          style={{
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: 'white',
            border: '1px solid #d9d9d9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer'
          }}
        >
          <SearchOutlined style={{ fontSize: 16, color: '#666' }} />
        </div>
      </div>

      {/* Contact Us Section */}
      {!isTabletOrMobile && (
        <div className="contact-section">
          <button className="contact-button" onClick={handleContactClick}>
            Contact Us
          </button>
        </div>
      )}
    </div>
  );
};

export default Navigation;